import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueCompositionAPI from '@vue/composition-api'

import VueCookies from 'vue-cookies'
import Select2 from 'v-select2-component'
import CKEditor from 'ckeditor4-vue';
import router from './router'
import store from './store'
import App from './App.vue'
import i18n from '@/libs/i18n/index.js'
import VueMeta from 'vue-meta'
import Cookies from 'js-cookie'
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)
// import VueRecord from '@codekraft-studio/vue-record'
// Vue.use(VueRecord)
// import VueHtml2Canvas from 'vue-html2canvas';
Vue.use(VueMeta)

// Vue.use(VueHtml2Canvas);
// import vuetify from './plugins/vuetify'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import Auth from './Apis/Auth';


import moment from 'moment'
moment.locale('ar')
Vue.prototype.moment = moment
Vue.use(CKEditor);


// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

Vue.component('Select2', Select2)

Vue.use(VueCookies)
Vue.use(CKEditor)
Vue.use(BootstrapVue);

// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
document.title = title;
create();
let mobile = Cookies.get('mobile');

Vue.prototype.$mobile = mobile;
Vue.prototype.$mobileTitle = Vue.observable({
  label: ''
});

/*

This code creates a new Vue instance,
which is the root of the Vue application.
The instance is configured with internationalization (i18n), routing (router), 
and state management (store). 
The render function is used to render the App component, and the $mount() method is used to mount the 
Vue instance to a DOM element with an id of 'app'.


*/

async function create() {
  await Auth.loggedIn();



  const app = new Vue({
    i18n,
    router,
    store,
    // vuetify,

    render: h => h(App),
  }).$mount('#app')

}